
import { Booking, BookingStatus, PaymentStatus, Quote, SidebarItem } from './types';

export const SIDEBAR_ITEMS: SidebarItem[] = [
  { label: 'Painel de Controle', icon: 'dashboard', path: '/', section: 'Principal' },
  { label: 'Calendário de Reservas', icon: 'calendar_today', path: '/calendar', section: 'Principal' },
  { label: 'Fazer Orçamento', icon: 'add_task', path: '/create-quote', section: 'Principal' },
  { label: 'Meus Orçamentos', icon: 'list_alt', path: '/my-quotes', section: 'Principal' },
  { label: 'Todas as Reservas', icon: 'receipt_long', path: '/all-bookings', section: 'Principal' },
  { label: 'Clientes', icon: 'groups', path: '/customers', section: 'Principal' },
  { label: 'Logística', icon: 'local_shipping', path: '/logistics', section: 'Operações' },
  { label: 'Tours', icon: 'explore', path: '/tours', section: 'Operações' },
  { label: 'Financeiro', icon: 'payments', path: '/finance', section: 'Operações' },
  { label: 'Relatórios', icon: 'assessment', path: '/reports', section: 'Operações' },
];

export const MOCK_BOOKINGS: Booking[] = [
  {
    id: '8ECD63C6',
    date: '14/07/26',
    time: '08:30:00',
    customerName: 'Nicole Cristina Gomes',
    customerEmail: 'nycole_crys@hotmail.com',
    origin: 'Brasil',
    tour: 'Circuito Chico',
    pax: '1',
    price: 160.0,
    currency: 'R$',
    status: BookingStatus.CONFIRMED,
    payment: PaymentStatus.PENDING,
  },
  {
    id: '6B404847',
    date: '10/07/26',
    time: '09:00:00',
    customerName: 'Pato Test',
    customerEmail: 'pato@test.com',
    origin: 'Argentina',
    tour: 'Navegação Isla Victoria',
    pax: '1',
    price: 450.0,
    currency: 'R$',
    status: BookingStatus.CONFIRMED,
    payment: PaymentStatus.PARTIAL,
  },
  {
    id: '2BE8353F',
    date: '20/11/25',
    time: '12:18:00',
    customerName: 'Madalena Teste',
    customerEmail: 'madalena@test.com',
    origin: 'Brasil',
    tour: 'Tour-6',
    pax: '2',
    price: 2600.0,
    currency: 'R$',
    status: BookingStatus.CONFIRMED,
    payment: PaymentStatus.PAID,
  },
  {
    id: '1DD8E664',
    date: '19/11/25',
    time: '08:00:00',
    customerName: 'Magda da Silva',
    customerEmail: 'magda@test.com',
    origin: 'Brasil',
    tour: 'Tour ao Cerro Catedral',
    pax: '5',
    price: 900.0,
    currency: 'R$',
    status: BookingStatus.CONFIRMED,
    payment: PaymentStatus.PENDING,
  },
];

export const MOCK_QUOTES: Quote[] = MOCK_BOOKINGS.map(b => ({
  ...b,
  createdAt: '11 Dez 2025',
  expiresAt: '10 Jan 2026',
}));

export const USER_AVATAR = "https://lh3.googleusercontent.com/aida-public/AB6AXuCtQQrYxO9LipBokS3407haHOyQoWIpD6mhwYDwV3AwULHQQX0ujTNm-tzBmuNPTAOhhdeLYIGnLnYkDGyfghAbjWMT_fu2FpFPcOu_GuMQX_oG3dbSR1RO5VkRbRd_wMFPRP9gCiysx7toRinr__aRETFEzb0yyDzdDO9WwAzoBoSQ6TFJM_yvu-AKrpW7WOAtSHqhdM67PltlETyEaHDOcO87B3fij53FCjNe89kHFtHF6UQiW9BLsPlneOCczWVkBhcrdi7wPgA";
export const APP_LOGO = "https://lh3.googleusercontent.com/aida-public/AB6AXuBfNoZF7T9KfO6bfvN1z4KjtcJTaEwk-XOESsvA21YASNMxaDuEczefrPlGl8xOWhY_lnc-5rZA_BMqU4I3_OyWxyLfUSDeJ2vyrJQ9llN3g7TcFXiYjndAXXtqa57jcoXzzANdpTSx4hd1PhTGVJYXY1NLuXwbVLl-fDwWMAJVoMGvu-LoIpusoe__rPEPLTvIXZrsVEZAnDFnB3i2SjxmC17QPIvI1ZiGDIYZ_n2co6JIV6pkBduLuSPLM9SUcHR7h6xd7RYdpww";
export const FLAG_BR = "https://lh3.googleusercontent.com/aida-public/AB6AXuCw57lMlOd41SRzC_6F6eId4uzPJwBJ018syCSAqQrVqOrFYov5jwtxM91bFERlOKLU7o0Gehsf9qXKANHwfcsRmGYnBAFX1dZDOB7kv8Ij5ddS-AT2q6Rmrq5CHS0lpsZe5_-fYJ6QUycj6NzXye9RxrPlBEk9R-jR_iS0YwPTMz2FzXjnWcj-yVYTinVryv5aK2N-nDQjgirz-Cu_CmLA-sCpEztQq50vDcJFHVuBLgKSH0tAD2VI4Syt8m3D64dkQEVfdUQj8J4";
